import React from 'react';

import { colors, Container, Row, Col, Typography } from '@ajaibid/components';
import { formatCurrency, formatDate } from '@ajaibid/utils';

import { useStockBuySellContext } from '../../hooks';

const OrderSummaryBottom = () => {
  const { formState, formKey, isAmend, isBuy, isSell, isLimitOrder, isAutoOrder } =
    useStockBuySellContext();

  return (
    <Container padding="16px 0px">
      <Row noGutters align="between">
        <Col size="auto">
          <Typography type="body" color={colors.NEUTRAL_7} margin={0}>
            Harga
          </Typography>
        </Col>
        <Col size="auto">
          <Typography type="body" bold margin={0} data-testid="txt-price">
            {formatCurrency(formState[formKey.INPUT_PRICE], 'IDR')}
          </Typography>
        </Col>
      </Row>

      {isAmend && (
        <Row noGutters align="between" marginTop={8}>
          <Col size="auto">
            <Typography type="body" color={colors.NEUTRAL_7} margin={0}>
              Aksi
            </Typography>
          </Col>
          <Col size="auto">
            <Typography type="body" bold margin={0} data-testid="txt-orderSide">
              {isBuy && 'Beli'}
              {isSell && 'Jual'}
            </Typography>
          </Col>
        </Row>
      )}

      <Row noGutters align="between" marginTop={8}>
        <Col size="auto">
          <Typography type="body" color={colors.NEUTRAL_7} margin={0}>
            Akun
          </Typography>
        </Col>
        <Col size="auto">
          <Typography type="body" bold margin={0} data-testid="txt-accountType">
            {formState[formKey.INPUT_ACCOUNT_TYPE]?.label}
          </Typography>
        </Col>
      </Row>

      <Row noGutters align="between" marginTop={8}>
        <Col size="auto">
          <Typography type="body" color={colors.NEUTRAL_7} margin={0}>
            Tipe Order
          </Typography>
        </Col>
        <Col size="auto">
          <Typography type="body" bold margin={0} data-testid="txt-orderType">
            {formState[formKey.TAB_ORDER_TYPE]?.name}
          </Typography>
        </Col>
      </Row>

      {isLimitOrder && (
        <Row noGutters align="between" marginTop={8}>
          <Col size="auto">
            <Typography type="body" color={colors.NEUTRAL_7} margin={0}>
              Periode
            </Typography>
          </Col>
          <Col size="auto">
            <Typography type="body" bold margin={0} data-testid="txt-limitOrderPeriod">
              {formState[formKey.INPUT_ORDER_PERIOD]?.label}
            </Typography>
          </Col>
        </Row>
      )}

      {isAutoOrder && (
        <>
          <Row noGutters align="between" marginTop={8}>
            <Col size="auto">
              <Typography type="body" color={colors.NEUTRAL_7} margin={0}>
                Periode
              </Typography>
            </Col>
            <Col size="auto">
              <Typography type="body" bold margin={0} data-testid="txt-autoOrderPeriod">
                {formatDate(formState[formKey.INPUT_START_DATE], 'D MMM YYYY')}
                {' - '}
                {formatDate(formState[formKey.INPUT_END_DATE], 'D MMM YYYY')}
              </Typography>
            </Col>
          </Row>
          <Row noGutters align="between" marginTop={8}>
            <Col size="auto">
              <Typography type="body" color={colors.NEUTRAL_7} margin={0}>
                {`Syarat ${(isBuy && 'Auto Order Buy') || (isSell && 'Auto Order Sell')}`}
              </Typography>
            </Col>
            <Col size="auto">
              <Typography type="body" bold margin={0} data-testid="txt-autoOrderThreshold">
                {`Harga ${formState[formKey.INPUT_THRESHOLD_COMPARATOR]?.label} `}
                {formatCurrency(formState[formKey.INPUT_THRESHOLD_VALUE], 'IDR')}
              </Typography>
            </Col>
          </Row>
        </>
      )}
    </Container>
  );
};

export default OrderSummaryBottom;
